import {z} from 'zod';

import {
  ArticleScopeArticleDefaultSupplierSchema,
  UpdateScopeSupplierArticleSchema,
  UpdateScopeWarehouseArticleSchema,
} from '@dms/api/warehouse';

export const OptionScopeSchema = z.enum(['all', 'select']);

export const OverviewFormSchema = z.object({
  basicInformation: z.object({
    supplierId: z.string(),
    publishedAt: z.string().nullish(),
    note: z.string().nullish(),
  }),
  articlesScope: z.object({
    articleScopeLimitToUpdateList: z.boolean(),
    branchScope: z.object({
      articleScopeBranchAll: z.boolean(),
      articleScopeBranches: z.array(z.string()).nullish(),
      option: OptionScopeSchema, // Only local use
    }),
    warehouseScope: z.object({
      articleScopeWarehouseAll: z.boolean(),
      articleScopeWarehouses: z.array(z.string()).nullish(),
      option: OptionScopeSchema, // Only local use
    }),
    articleScopeArticleDefaultSupplier: ArticleScopeArticleDefaultSupplierSchema,
  }),
  updateScope: z.object({
    updateScopeSupplierArticleAll: z.boolean(),
    updateScopeSupplierArticle: z.array(UpdateScopeSupplierArticleSchema).nullish(),
    updateScopeWarehouseArticleAll: z.boolean(),
    updateScopeWarehouseArticle: z.array(UpdateScopeWarehouseArticleSchema).nullish(),
  }),
});

export type OverviewForm = z.infer<typeof OverviewFormSchema>;
